import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import styles from "./styles.module.css";

export function CircularLoader(): JSX.Element {
  return (
    <div className={styles["loader-container"]}>{<CircularProgress />}</div>
  );
}
